import EditableInputField from './EditableInputField';

export default EditableInputField;
